const r = () => "MGA";
export {
  r as useUserJurisdiction
};
